import { render, staticRenderFns } from "./TeamActivity.vue?vue&type=template&id=5715dbf2&scoped=true&"
import script from "./TeamActivity.vue?vue&type=script&lang=js&"
export * from "./TeamActivity.vue?vue&type=script&lang=js&"
import style0 from "./TeamActivity.vue?vue&type=style&index=0&id=5715dbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715dbf2",
  null
  
)

export default component.exports